import { Button, Modal, Table, TableColumnType } from "antd";
import { useState } from "react";
import { IListMaterialAwb } from "../../models/Research";
import { useGetProductionListItemAwbs } from "../../query/ProductionQuery";
import { useGetListAwbByMaterialId } from "../../query/ReseachQuery";
import ModalAwbDetail from "./ModalAwbDetail";

interface IModalViewListAwbProps {
  isOpen: boolean;
  onClose: () => void;
  materialId: number;
  type?: "research" | "production";
}

const ModalViewListAwb = ({
  isOpen,
  onClose,
  materialId,
  type = "research",
}: IModalViewListAwbProps) => {
  const { data: listAwb, isLoading: researchLoading } =
    useGetListAwbByMaterialId(materialId);
  const { data: listProductionAwb, isLoading: productionLoading } =
    useGetProductionListItemAwbs(materialId);

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [awbCode, setAwbCode] = useState<string>("");

  const data = (type === "research" ? listAwb : listProductionAwb) as
    | IListMaterialAwb[]
    | undefined;
  const isLoading = type === "research" ? researchLoading : productionLoading;

  const columns: TableColumnType<IListMaterialAwb>[] = [
    {
      title: "AWB",
      dataIndex: "awb",
      key: "awb",
      align: "center",
    },
    {
      title: "Ngày dự kiến giao",
      dataIndex: "eta",
      key: "eta",
      align: "center",
    },
    {
      title: "Xem",
      dataIndex: "view",
      key: "view",
      align: "center",
      render: (value: any, record: IListMaterialAwb) => {
        return (
          <div>
            <Button
              type="link"
              onClick={() => {
                setAwbCode(record.awb);
                setOpenModal(true);
              }}
            >
              Xem
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <ModalAwbDetail
        setOpenDetailModal={setOpenModal}
        openDetailModal={openModal}
        awbCode={awbCode}
      />
      <Modal open={isOpen} onCancel={onClose} title="Danh sách AWB">
        <Table dataSource={data} columns={columns} loading={isLoading} />
      </Modal>
    </div>
  );
};

export default ModalViewListAwb;
